// extracted by mini-css-extract-plugin
export var rateTable = "_64-0";